import React from 'react';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductStockCheckMarkType, ProductStockStatusType } from 'autogen/swagger/all';
import Status from 'components/Status';
import type { StatusProps } from 'components/Status/StatusDefault';
import usePageContext from 'hooks/user/usePageContext';
import { em } from 'modules/helpers/style';
import { SvgSprite } from 'modules/svgSprite';
import { breakpoint, sizes } from 'variables';

type UnifyStockStatusType = ProductStockCheckMarkType | ProductStockStatusType;

const getIndicatorColor = (type?: UnifyStockStatusType): StatusProps['color'] => {
    switch (type) {
        case 'Green':
        case 'IsInStock':
            return 'Green';
        case 'Yellow':
        case 'FewInStock':
            return 'Yellow';
        case 'Red':
        case 'SoldOut':
            return 'Red';
        case 'Black':
        default:
            return 'Neutral';
    }
};

const Checkmark = styled(SvgSprite)`
    display: inline;
    width: 100%;
    height: 100%;
    max-width: 12px;
    max-height: 12px;
    margin-right: 5px;

    ${breakpoint.up(sizes.md)} {
        max-width: 16px;
        max-height: 16px;
    }
`;

const StyledDot = styled(Status)`
    margin-right: ${Spacing8};
    margin-top: ${em(6)};
`;

interface IStockIndicator {
    checkmarkType?: UnifyStockStatusType;
    useDot?: boolean;
}

export default function StockIndicator({ checkmarkType, useDot = false }: IStockIndicator): JSX.Element {
    const { brandContext } = usePageContext();
    const type = brandContext === 'chanel' ? 'Black' : checkmarkType;

    if (useDot) {
        return <StyledDot size={6} color={getIndicatorColor(type)} />;
    }

    return <Checkmark sprite="Checkmark" fill={getIndicatorColor(type)} />;
}
